import React, { useState } from 'react';
import { MainButtonInput } from "../../../mainComponent/mainButtonInput";
import { MainInput } from '../../../mainComponent/mainInput';
import { Link } from 'react-router-dom';
import { THEME_COLOR } from '../../../config';
import TouristAppointmentsApi from '../../../services/TouristAppointmentsApi';
import AddCircleIcon from '@mui/icons-material/AddCircle';

function AddActivities(props) {
    const { doctorId } = props;
    const [activityDetails, setActivityDetails] = useState({
        name: '',
        details: ['']
    });
    const { AddActivities } = TouristAppointmentsApi();

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setActivityDetails(prev => ({ ...prev, [name]: value }));
    };

    const addInputBox = () => {
        setActivityDetails(prev => ({
            ...prev,
            details: [...prev.details, '']
        }));
    }

    const handleActivityInput = (e, index) => {
        const newDetails = [...activityDetails.details];
        newDetails[index] = e.target.value;
        setActivityDetails(prev => ({
            ...prev,
            details: newDetails
        }));
    }

    async function handleActivityData(e) {
        e.preventDefault();
        const activityData = {
            activity: activityDetails.name,
            details: activityDetails.details.filter(detail => detail.trim() !== '')
        }
        AddActivities(activityData)
            .then(() => {
                // Handle success
            })
        props.onSubmit();
    }

    return (
        <form encType='multipart/form-data' onSubmit={handleActivityData}>
            <div className="col-lg-12">
                <div>
                    <label className="font_weight">Activity Name</label>
                    <MainInput
                        type="text"
                        name="name"
                        onChange={handleInputChange}
                        value={activityDetails.name}
                        placeholder="Activity Name" >
                    </MainInput>
                </div>

                <label className="font_weight">Activity Details</label>
                <div className='row'>
                    <div className="mb-3 col-lg-11">
                        <MainInput
                            type="text"
                            value={activityDetails.details[0] || ''}
                            onChange={(e) => handleActivityInput(e, 0)}
                            placeholder="Activity details" >
                        </MainInput>
                    </div>
                    <div className="col-lg-1">
                        <Link to="#" onClick={() => addInputBox()}>
                            <AddCircleIcon style={{ fontSize: 25, color: THEME_COLOR, marginLeft: 5, marginTop: 5 }} />
                        </Link>
                    </div>
                </div>

                <div className="col-lg-12">
                    {activityDetails.details.slice(1).map((data, i) => (
                        <div key={i+1}>
                            <MainInput
                                type="text"
                                value={data || ''}
                                onChange={(e) => handleActivityInput(e, i+1)}
                                placeholder="Activity details" >
                            </MainInput>
                        </div>
                    ))}
                </div>

                <div className="text-center p-2 add_top_30">
                    <MainButtonInput>Save</MainButtonInput>
                </div>
            </div>
        </form>
    )
}
export { AddActivities }
